import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

type ChipTone = "teal" | "coral" | "line" | "muted" | "petrol";

const CHIP_TONE: Record<ChipTone, string> = {
	teal: "bg-info/10 text-info border-info/25",
	coral: "bg-destructive/10 text-destructive border-destructive/30",
	line: "bg-border/50 text-foreground border-border",
	muted: "bg-transparent text-muted-foreground border-border",
	petrol: "bg-primary/10 text-primary border-primary/25",
};

export function Chip({
	children,
	tone = "line",
	className,
}: {
	children: ReactNode;
	tone?: ChipTone;
	className?: string;
}) {
	return (
		<span
			className={cn(
				"inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-xs font-medium leading-none",
				CHIP_TONE[tone],
				className,
			)}
		>
			{children}
		</span>
	);
}
